import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    textLeft: PropTypes.bool,
    staggered: PropTypes.bool
};
const DetailsBanner = createComponent({
    displayName: 'DetailsBanner',
    root: 'div',
    propTypes,
    propConfig: {
        classNames ({ textLeft , staggered  }) {
            let classesSet = new Set([
                'swan-details-banner'
            ]);
            if (textLeft) classesSet.add('swan-details-banner-text-left');
            if (staggered) classesSet = new Set([
                ...classesSet,
                'swan-details-banner-background-staggered'
            ]);
            return classesSet;
        }
    }
});
DetailsBanner.defaultProps = {
    staggered: false,
    textLeft: false,
    bgShort: true
};

export { DetailsBanner };
